// extracted by mini-css-extract-plugin
export default {"zoomModal":"u1-z","image":"v1-z","button":"w1-z","isOverlayShown":"x1-z"};